import { DURATION_CONFIG_OPTIONS } from '@vakantiesnl/services/src/util/durations';
import { type Search } from '@vakantiesnl/types/src';

import { type MatrixOffers } from './useGetDepartureDateMatrixOffers';

export const findDurationConfigs = (targetDays: number[]): number[] => {
	const targetSet = new Set(targetDays);
	const result = Object.values(DURATION_CONFIG_OPTIONS)
		.filter((config) => config.array.some((day) => targetSet.has(day)))
		.flatMap((config) => config.array);

	return result.length > 0 ? result : DURATION_CONFIG_OPTIONS.default.array;
};

export function mapMatrixOffers(offers: Search.OfferItem[], durations: number[]): MatrixOffers {
	const mapped: MatrixOffers = {};

	/** Create an null array for the length of the durations */
	offers.forEach((offer) => {
		const departureDate = offer.departureDateYYYYMMDD;

		if (!mapped[departureDate]) {
			mapped[departureDate] = new Array(durations.length).fill(null);
		}
	});

	/** Fill in the nulls with offers */
	offers.forEach((offer) => {
		const departureDate = offer.departureDateYYYYMMDD;
		const duration = offer.durationNights;

		/**  Find the index of the duration in the durations list */
		const index = durations.indexOf(duration);

		/** Only save duration if it exists, otherwise there's no offer and it should still be null */
		if (index !== -1) {
			mapped[departureDate][index] = offer;
		}
	});

	// Sort by departureDate
	const sorted: MatrixOffers = {};
	Object.keys(mapped)
		.sort() // YYYYMMDD sorts correctly
		.forEach((key) => {
			sorted[key] = mapped[key];
		});

	return sorted;
}
